export default "__VITE_ASSET__tiCX7mHt__"